import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";

function ComparativeNutrients() {
  const patientLogin = useSelector((state) => state.patient.patientLogin);
  const [selectedCategory, setSelectedCategory] = useState("Please-select");
  const [ressponseCategory, setRessponseCategory] = useState("");
  const [majorCategory, setMajorCategory] = useState("");
  const [loadingCategory, setLoadingCategory] = useState(false);

  const [selectedSecondCategory, setSelectedSecondCategory] = useState();
  const [selectedSecondCategory2, setSelectedSecondCategory2] = useState();
  const [selectedSecondCategory3, setSelectedSecondCategory3] = useState();
  const [loadingSecondCategory, setLoadingSecondCategory] = useState(false);

  const [responseSecoundCate1, setRresponseSecoundCate1] = useState();
  const [responseSecoundCate2, setRresponseSecoundCate2] = useState();
  const [responseSecoundCate3, setRresponseSecoundCate3] = useState();

  // Weight states with default value of 100 grams
  const [weight1, setWeight1] = useState(100);
  const [weight2, setWeight2] = useState(100);
  const [weight3, setWeight3] = useState(100);

  // Store selected item names for display
  const [selectedItem1, setSelectedItem1] = useState("");
  const [selectedItem2, setSelectedItem2] = useState("");
  const [selectedItem3, setSelectedItem3] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoadingCategory(true);
      try {
        const response = await SendPostRequest("home/fruits", {
          logged_id: patientLogin?.logged_id,
          category: selectedCategory,
        });
        setRessponseCategory(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingCategory(false);
      }
    };

    fetchData();
  }, [selectedCategory]);

  // getting major categories
  useEffect(() => {
    if (selectedCategory === "Please Select") {
      setSelectedCategory([]);
      return;
    }

    const fetchData = async () => {
      try {
        const response = await SendPostRequest("home/diet_categories", {
          host: "drburhan.clinta.biz",
          type: "full",
        });
        setMajorCategory(response.data.category);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    };

    fetchData();
  }, []);

  // getting data of 1st category
  useEffect(() => {
    if (selectedSecondCategory === "Please Select") {
      setSelectedSecondCategory([]);
      return;
    }

    const fetchData = async () => {
      try {
        if (selectedSecondCategory !== "") {
          const response = await SendPostRequest("home/diet_facts", {
            host: "drburhan.clinta.biz",
            diet_id: selectedSecondCategory,
            weight: weight1 // Send weight in API request
          });
          setRresponseSecoundCate1(response.data);

          // Find and set the selected item name
          const selectedItem = ressponseCategory?.find(item => item?.UID === selectedSecondCategory);
          if (selectedItem) {
            setSelectedItem1(selectedItem.Name);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    };

    fetchData();
  }, [selectedSecondCategory, weight1, ressponseCategory]);

  // getting data of 2nd category
  useEffect(() => {
    if (selectedSecondCategory2 === "Please Select") {
      setSelectedSecondCategory2("");
      return;
    }

    const fetchData = async () => {
      try {
        if (selectedSecondCategory2 !== "") {
          const response = await SendPostRequest("home/diet_facts", {
            host: "drburhan.clinta.biz",
            diet_id: selectedSecondCategory2,
            weight: weight2 // Send weight in API request
          });
          setRresponseSecoundCate2(response.data);

          // Find and set the selected item name
          const selectedItem = ressponseCategory?.find(item => item?.UID === selectedSecondCategory2);
          if (selectedItem) {
            setSelectedItem2(selectedItem.Name);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    };

    fetchData();
  }, [selectedSecondCategory2, weight2, ressponseCategory]);

  // getting data of 3rd category
  useEffect(() => {
    if (selectedSecondCategory3 === "Please Select") {
      setSelectedSecondCategory3("");
      return;
    }

    const fetchData = async () => {
      try {
        if (selectedSecondCategory3 !== "") {
          const response = await SendPostRequest("home/diet_facts", {
            host: "drburhan.clinta.biz",
            diet_id: selectedSecondCategory3,
            weight: weight3 // Send weight in API request
          });
          setRresponseSecoundCate3(response.data);

          // Find and set the selected item name
          const selectedItem = ressponseCategory?.find(item => item?.UID === selectedSecondCategory3);
          if (selectedItem) {
            setSelectedItem3(selectedItem.Name);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    };

    fetchData();
  }, [selectedSecondCategory3, weight3, ressponseCategory]);

  const handleSelectChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleChangeSecondCategory = (e) => {
    const value = e.target.value;
    setSelectedSecondCategory(value);
    if (value === "") {
      setSelectedItem1("");
    }
  };

  const handleChangeSecondCategory2 = (e) => {
    const value = e.target.value;
    setSelectedSecondCategory2(value);
    if (value === "") {
      setSelectedItem2("");
    }
  };

  const handleChangeSecondCategory3 = (e) => {
    const value = e.target.value;
    setSelectedSecondCategory3(value);
    if (value === "") {
      setSelectedItem3("");
    }
  };

  const handleWeightChange1 = (e) => {
    const value = e.target.value;
    // Allow empty value for better UX while typing
    if (value === "") {
      setWeight1("");
      return;
    }

    const numValue = parseInt(value);
    // Only set if it's a valid number and >= 1
    if (!isNaN(numValue) && numValue >= 1) {
      setWeight1(numValue);
    }
  };

  const handleWeightChange2 = (e) => {
    const value = e.target.value;
    // Allow empty value for better UX while typing
    if (value === "") {
      setWeight2("");
      return;
    }

    const numValue = parseInt(value);
    // Only set if it's a valid number and >= 1
    if (!isNaN(numValue) && numValue >= 1) {
      setWeight2(numValue);
    }
  };

  const handleWeightChange3 = (e) => {
    const value = e.target.value;
    // Allow empty value for better UX while typing
    if (value === "") {
      setWeight3("");
      return;
    }

    const numValue = parseInt(value);
    // Only set if it's a valid number and >= 1
    if (!isNaN(numValue) && numValue >= 1) {
      setWeight3(numValue);
    }
  };

  // Handle blur event to set default value if empty
  const handleWeightBlur1 = (e) => {
    if (weight1 === "" || weight1 < 1) {
      setWeight1(100);
    }
  };

  const handleWeightBlur2 = (e) => {
    if (weight2 === "" || weight2 < 1) {
      setWeight2(100);
    }
  };

  const handleWeightBlur3 = (e) => {
    if (weight3 === "" || weight3 < 1) {
      setWeight3(100);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <div className="ComparativeNutrients">
      <h2>Comparative Nutrients</h2>

      <div className="filter">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <label htmlFor="">Please Select Category:</label>
            <select name="" id="" onChange={handleSelectChange}>
              <option value="Please-select">Please Select</option>
              <option value="">All</option>
              <option value="fruits">Fruits</option>
              <option value="dry-fruites">Dry Fruits</option>
              <option value="vegetables">Vegetables</option>
              <option value="pulses-grains">Pulses Grains</option>
              <option value="miscellaneous">Miscellaneous</option>
            </select>
            {!isMobile ? (
              <label htmlFor="weight1" style={{ fontSize: '13px', marginRight: '5px', paddingTop: "15px" }}>Required Weight In Grams:</label>
            ) : null}

          </div>

          {/* First Comparison Column */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <label htmlFor="">Compare with:</label>
            <select
              name="second-category"
              id=""
              onChange={handleChangeSecondCategory}
            >
              <option value="">Please Select Category</option>
              {ressponseCategory &&
                ressponseCategory?.length > 0 &&
                ressponseCategory.map((data, index) => (
                  <option key={index} value={data?.UID}>
                    {data?.Name} - {data?.UrduName}
                  </option>
                ))}
            </select>
            <div className="weight-input" style={{ marginTop: '8px' }}>
              <input
                type="number"
                id="weight1"
                value={weight1}
                onChange={handleWeightChange1}
                onBlur={handleWeightBlur1}
                min="1"
                className="comprehensive-weight-inputs"
                placeholder="Weight in grams"
              />
            </div>
          </div>

          {/* Second Comparison Column */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <label htmlFor="">Compare with:</label>
            <select
              name="second-category"
              id=""
              onChange={handleChangeSecondCategory2}
            >
              <option value="">Please Select Category</option>
              {ressponseCategory &&
                ressponseCategory?.length > 0 &&
                ressponseCategory.map((data, index) => (
                  <option key={index} value={data?.UID}>
                    {data?.Name} - {data?.UrduName}
                  </option>
                ))}
            </select>
            <div className="weight-input" style={{ marginTop: '8px' }}>
              <input
                type="number"
                id="weight2"
                value={weight2}
                onChange={handleWeightChange2}
                onBlur={handleWeightBlur2}
                className="comprehensive-weight-inputs"
                min="1"
                placeholder="Weight in grams"
              />
            </div>
          </div>

          {/* Third Comparison Column */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <label htmlFor="">Compare with:</label>
            <select
              name="second-category"
              id=""
              onChange={handleChangeSecondCategory3}
            >
              <option value="">Please Select Category</option>
              {loadingCategory ? (
                <option value="">Wait...</option>
              ) : (
                ressponseCategory &&
                ressponseCategory?.length > 0 &&
                ressponseCategory.map((data, index) => (
                  <option key={index} value={data?.UID}>
                    {data?.Name} - {data?.UrduName}
                  </option>
                ))
              )}
            </select>
            <div className="weight-input" style={{ marginTop: '8px' }}>
              <input
                type="number"
                id="weight3"
                value={weight3}
                onChange={handleWeightChange3}
                onBlur={handleWeightBlur3}
                min="1"
                className="comprehensive-weight-inputs"
                placeholder="Weight in grams"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table">
          <thead className="nutritional-items-table-th">
            <tr className="nutritional-items-table-tr">
              <th style={{ width: "25%", textTransform: "capitalize" }}>Nutritional Items</th>
              <th style={{ width: "25%", textAlign: "center" }}>
                {selectedItem1 ? (
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                      {selectedItem1}{" "}({weight1}g)
                    </div>
                    {/* <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                    Weight: {weight1}g
                  </div> */}
                  </div>
                ) : (
                  <div style={{ fontSize: '14px', fontWeight: 'bold', }}>
                    Select Item
                  </div>
                )}
              </th>
              <th style={{ width: "25%", textAlign: "center" }}>
                {selectedItem2 ? (
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                      {selectedItem2}{" "}({weight2}g)
                    </div>
                    {/* <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                    Weight: {weight2}g
                  </div> */}
                  </div>
                ) : (
                  <div style={{ fontSize: '14px', fontWeight: 'bold', }}>
                    Select Item
                  </div>
                )}
              </th>
              <th style={{ width: "25%", textAlign: "center" }}>
                {selectedItem3 ? (
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                      {selectedItem3}{" "}({weight3}g)
                    </div>
                    {/* <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                    Weight: {weight3}g
                  </div> */}
                  </div>
                ) : (
                  <div style={{ fontSize: '14px', fontWeight: 'bold', }}>
                    Select Item
                  </div>
                )}
              </th>
            </tr>
          </thead>

          {majorCategory &&
            Object.entries(majorCategory).map(
              ([categoryKey, categoryValue], key) => (
                <React.Fragment key={key}>
                  <thead>
                    <tr>
                      <th colSpan="4" style={{ backgroundColor: '#f8f9fa' }}>{categoryKey.toUpperCase()}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoryValue.map((item, key) => (
                      <tr key={key}>
                        <td style={{ width: "25%" }}>
                          {item.title.toUpperCase()}
                        </td>

                        {/* First Comparison Column Data - Display exact API response */}
                        <td
                          id={"a_" + item?.id}
                          key={key}
                          style={{ width: "25%", textAlign: "center" }}
                        >
                          {(() => {
                            let is_val = 0;
                            let result =
                              responseSecoundCate1?.length < 1 ? (
                                <p>--</p>
                              ) : (
                                responseSecoundCate1?.map((subcat, key) =>
                                  Object.entries(subcat)
                                    .filter(([key, value]) => {
                                      if (item.id === key) {
                                        is_val = 1;
                                        return true;
                                      }
                                      return false;
                                    })
                                    .map(([key, value]) => (
                                      <p key={key}>
                                        {value + " " + item.unit}
                                      </p>
                                    ))
                                )
                              );
                            if (is_val === 0) return "--";
                            return result;
                          })()}
                        </td>

                        {/* Second Comparison Column Data - Display exact API response */}
                        <td
                          id={"b_" + item?.id}
                          key={key}
                          style={{ width: "25%", textAlign: "center" }}
                        >
                          {(() => {
                            let is_val = 0;
                            let result =
                              responseSecoundCate2?.length < 1 ? (
                                <p>--</p>
                              ) : (
                                responseSecoundCate2?.map((subcat, key) =>
                                  Object.entries(subcat)
                                    .filter(([key, value]) => {
                                      if (item.id === key) {
                                        is_val = 1;
                                        return true;
                                      }
                                      return false;
                                    })
                                    .map(([key, value]) => (
                                      <p key={key}>
                                        {value + " " + item.unit}
                                      </p>
                                    ))
                                )
                              );
                            if (is_val === 0) return "--";
                            return result;
                          })()}
                        </td>

                        {/* Third Comparison Column Data - Display exact API response */}
                        <td
                          id={"c_" + item?.id}
                          key={key}
                          style={{ width: "25%", textAlign: "center" }}
                        >
                          {(() => {
                            let is_val = 0;
                            let result =
                              responseSecoundCate3?.length < 1 ? (
                                <p>--</p>
                              ) : (
                                responseSecoundCate3?.map((subcat, key) =>
                                  Object.entries(subcat)
                                    .filter(([key, value]) => {
                                      if (item.id === key) {
                                        is_val = 1;
                                        return true;
                                      }
                                      return false;
                                    })
                                    .map(([key, value]) => (
                                      <p key={key}>
                                        {value + " " + item.unit}
                                      </p>
                                    ))
                                )
                              );
                            if (is_val === 0) return "--";
                            return result;
                          })()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </React.Fragment>
              )
            )}
        </table>
      </div>
    </div>
  );
}

export default ComparativeNutrients;